export default {
  "fontElementMap": "AwnIM",
  "imageCaption": "ch2rA"
};